import type { ReactElement } from 'react';
import { Route } from 'react-router';

import { AppLayout } from '@/layouts/AppLayout';
import { DesignReviewPage } from '@/pages/DesignReviewPage';
import { ForgotPasswordPage } from '@/pages/ForgotPasswordPage';
import { HomePage } from '@/pages/HomePage';
import { LoginPage } from '@/pages/LoginPage';
import { NewCaseDetailsPage } from '@/pages/NewCaseDetailsPage';
import { NewCasePage } from '@/pages/NewCasePage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { OrderDetailsPage } from '@/pages/OrderDetailsPage';
import { OrganizationPage } from '@/pages/OrganizationPage';
import { OrdersPage } from '@/pages/OrdersPage';
import { RegisterPage } from '@/pages/RegisterPage';
import { ResetPasswordPage } from '@/pages/ResetPasswordPage';
import { ScanRevisionReviewPage } from '@/pages/ScanRevisionReviewPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { VerifyEmailPage } from '@/pages/VerifyEmailPage';

import { ProtectedRoute } from './ProtectedRoute';

export function appRouteElements(layout: ReactElement = <AppLayout />) {
  return (
    <Route element={layout}>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/register/organization" element={<OrganizationPage />} />
        <Route index element={<HomePage />} />
        <Route path="/cases/new" element={<NewCasePage />} />
        <Route path="/cases/new/details" element={<NewCaseDetailsPage />} />
        <Route path="/cases" element={<OrdersPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/cases/:orderId/scan-revision" element={<ScanRevisionReviewPage />} />
        <Route path="/cases/:orderId/review" element={<DesignReviewPage />} />
        <Route path="/cases/:orderId" element={<OrderDetailsPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Route>
  );
}
